import { NEW_PRESCRIPTION_AND_UPLOAD } from "../../state/state/constants.js";
function isNewPrescriptionAndUpload(prescription) {
  return prescription === NEW_PRESCRIPTION_AND_UPLOAD;
}
export {
  isNewPrescriptionAndUpload
};
//# sourceMappingURL=is-new-prescription-upload.js.map
